<template>
  <div class="pageFlex word" :style="{color: color || 'var(--redColor)'}" @click="onClick">
    <i class='iconfont left' :class="iconName" v-if="iconLeft"></i>
    <span>{{word}}</span>
    <i :style="{fontSize: fontSize}" class='iconfont right' :class="iconName" v-if="!iconLeft"></i>
  </div>
</template>

<script>
export default {
  props: {
    iconName: String,
    word: String,
    color: String,
    fontSize: String,
    iconLeft: {
      type: Boolean,
      default: true
    },
  },
  methods:{
     onClick(){
       this.$emit("onClick",1);
     }
  }
};
</script>

<style scoped lang="less">
.word{
  padding: 1px 0;
  .left{
    margin-right: 4px;
  }
  .right{
    margin-left: 4px;
  }
  .iconfont,
  span{
    vertical-align: middle;
    line-height: 1;
  }
  .iconfont{
    display: inline-block;
    font-size: 20px;
  } 
}
</style>
